import { ApiUrl } from "../consts/api";

// string-extensions.ts
declare global {
  interface String {
    toApiImage(blankImage?: string): string;
  }
}
export {};
String.prototype.toApiImage = function (blankImage = ""): string {
  if (this === null || this === undefined) {
    return `${ApiUrl}/${blankImage}`;
  }
  if (this.trim().length === 0) {
    return `${ApiUrl}/${blankImage}`;
  }
  return `${ApiUrl}/${this}`;
};

export const toApiImage = (
  path: string | null | undefined,
  blankImage: string = "",
): string => {
  if (!path || path.trim().length === 0) {
    return `${ApiUrl}/${blankImage}`;
  }
  return `${ApiUrl}/${path}`;
};
